import { AccountBoxOutlineIcon } from './AccountBoxOutlineIcon';

/**
 * author: Google
 * id 537261C5-1AF6-478F-A8BA-4349865D9C1C
 * name account-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-box-outline.svg
 * tags
 * - Account / User 
 */
export const SelfieOutlineIcon = AccountBoxOutlineIcon;
export default SelfieOutlineIcon